/** Shopify CDN: Minification failed

Line 37:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 38:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 38:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 39:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 39:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 41:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 51:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 55:33 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 25:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 26:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 26:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 27:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 27:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 29:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 39:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 43:33 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 13:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 14:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 14:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 15:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 15:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 17:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 27:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 31:33 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
(async () => {
    const { $show } = await importModule('Utils');
    const { Core } = await importModule('Core');

    customElements.define('collection-loader', class extends Core {
        elements = {
            select: 'x-select',
            input: '[data-sort-input]'
        };

        subscriptions = {
            'collection:loading': '_collectionLoadingHandler'
        };

        render() {
            this.subscribe('collection:loading')
        }

        _collectionLoadingHandler() {
            $show(this);
        }
        
    })
})();